module.exports = __webpack_public_path__ + "static/Social App-4d8d7fa77f86ace7fb46c77b4c5a981f.svg";